module.exports = __webpack_public_path__ + "img/prof_female.5b9f27cf.svg";